export const statsigIdentifer = 'client-ESNh8aiKay47In9nezTYgqysjKxOp9VKtLDeqaCwYb3';
